/**
 * @generated SignedSource<<0e861d8f16bffbbd90aacdc48a82287e>>
 * @relayHash 3e33e72b6548910557838772437690a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bff615b7752f36899326f0bc3c951340ca1b8d705f2b44bb34372d6dcd9acb69

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type handoffConfig_csmAiHubQuery$variables = {
  helpCenterAri: string;
};
export type handoffConfig_csmAiHubQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly __typename: "CsmAiHub";
    readonly " $fragmentSpreads": FragmentRefs<"configuration_AtlassianCsmHandoffConfig_queryReference">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type handoffConfig_csmAiHubQuery = {
  response: handoffConfig_csmAiHubQuery$data;
  variables: handoffConfig_csmAiHubQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "handoffConfig_csmAiHubQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "kind": "LinkedField",
          "name": "csmAi_getAiHubByHelpCenterAri",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "configuration_AtlassianCsmHandoffConfig_queryReference"
                }
              ],
              "type": "CsmAiHub"
            }
          ]
        },
        "action": "THROW",
        "path": "csmAi_getAiHubByHelpCenterAri"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "handoffConfig_csmAiHubQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "handoffConfigs",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "enabled"
                      },
                      (v3/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "connectorConfiguration",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "message"
                              }
                            ],
                            "type": "CsmAiMessageHandoff"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "formId"
                              }
                            ],
                            "type": "CsmAiTicketingHandoff"
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiHandoffConfig"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bff615b7752f36899326f0bc3c951340ca1b8d705f2b44bb34372d6dcd9acb69",
    "metadata": {},
    "name": "handoffConfig_csmAiHubQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b48226f0209d788d92ecab37f14e92ea";

export default node;
